<template>
    <img
        v-if="avatarUrl && !imgError"
        :src="avatarUrl"
        :width="size"
        :height="size"
        loading="lazy"
        class="rounded-full object-cover flex-shrink-0"
        :style="{ width: size + 'px', height: size + 'px' }"
        :alt="displayName"
        @error="imgError = true"
    />
    <div
        v-else-if="initials"
        class="rounded-full flex items-center justify-center flex-shrink-0 font-semibold text-white select-none"
        :style="{ width: size + 'px', height: size + 'px', backgroundColor: bgColor, fontSize: Math.max(10, Math.round(size * 0.38)) + 'px' }"
        :title="displayName"
        aria-hidden="true"
    >
        {{ initials }}
    </div>
    <div
        v-else
        class="rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center flex-shrink-0"
        :style="{ width: size + 'px', height: size + 'px' }"
        aria-hidden="true"
    >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-500 dark:text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
    </div>
</template>

<script setup>
import { computed, ref, watch, defineProps } from 'vue';

const props = defineProps({
    user: {
        type: Object,
        default: () => ({})
    },
    size: {
        type: Number,
        default: 32
    }
});

const imgError = ref(false);
watch(() => props.user?.avatarUrl, () => { imgError.value = false; });

const avatarUrl = computed(() => props.user?.avatarUrl || props.user?.avatar_url || '');
const displayName = computed(() => props.user?.name || props.user?.full_name || props.user?.email || 'User');

const initials = computed(() => {
    const name = (props.user?.name || props.user?.full_name || '').trim();
    if (name) {
        const parts = name.split(/\s+/).filter(Boolean);
        if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    const email = (props.user?.email || '').trim();
    if (email) return email.slice(0, 2).toUpperCase();
    return '';
});

const PALETTE = ['#6366f1', '#8b5cf6', '#0ea5e9', '#14b8a6', '#10b981', '#f59e0b', '#f97316', '#f43f5e'];

const bgColor = computed(() => {
    const seed = String(props.user?.id || props.user?._id || props.user?.email || props.user?.name || '?');
    let hash = 0x811c9dc5;
    for (let i = 0; i < seed.length; i++) {
        hash ^= seed.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return PALETTE[hash % PALETTE.length];
});
</script>
